// Date format helper
declare global {
  interface Date {
    format(fmt: string): string;
  }
}

Date.prototype.format = function (fmt: string): string {
  const o: Record<string, number> = {
    "M+": this.getMonth() + 1,
    "d+": this.getDate(),
    "h+": this.getHours(),
    "m+": this.getMinutes(),
    "s+": this.getSeconds(),
    "q+": Math.floor((this.getMonth() + 3) / 3),
    S: this.getMilliseconds(),
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length),
    );
  }

  for (const k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1
          ? o[k].toString()
          : ("00" + o[k]).substr(("" + o[k]).length),
      );
    }
  }

  return fmt;
};

interface ESHit {
  _source: any;
}

interface ESResponse {
  hits: {
    hits: ESHit[];
  };
}

interface TrendData {
  x: string[];
  y: number[];
  ty: number[];
  maxMiny: number[];
  minMiny: number[];
  maxMaxy: number[];
  minMaxy: number[];
  top1s: number[];
  top2s: number[];
  top3s: number[];
  top4s: number[];
  maxMiny2: number[];
  minMiny2: number[];
  maxMaxy2: number[];

  minMaxy2?: number[];
  maxMiny3: number[];
  minMiny3: number[];
  maxMaxy3: number[];

  minMaxy3?: number[];
  gaps: number[];
  g1: number[];
  g2: number[];
  g1a: number[];
  g2a: number[];
  [key: string]: any;
}

export function processTrendData(result: ESResponse, name: string): TrendData {
  const codes = ["20", "21", "22", "23"];
  const codeMapping: Record<string, string> = {
    "20": "21",
    "21": "20",
    "22": "23",
    "23": "22",
  };

  let alls: any[] = [];
  const x: string[] = [];
  const y: number[] = [];
  const ty: number[] = [];
  const maxMiny: number[] = [];
  const minMiny: number[] = [];
  const maxMaxy: number[] = [];
  const minMaxy: number[] = [];
  const maxMiny2: number[] = [];
  const minMiny2: number[] = [];
  const maxMaxy2: number[] = [];

  const minMaxy2: number[] = [];
  const maxMiny3: number[] = [];
  const minMiny3: number[] = [];
  const maxMaxy3: number[] = [];

  const minMaxy3: number[] = [];
  const top1s: number[] = [];
  const top2s: number[] = [];
  const top3s: number[] = [];
  const top4s: number[] = [];
  const g1: number[] = [];
  const g2: number[] = [];
  const g1a: number[] = [];
  const g2a: number[] = [];
  const gaps: number[] = [];

  let total = 0;
  let totalT = 0;
  let totalMaxMin = 0;
  let totalMinMin = 0;
  let totalMaxMax = 0;
  let totalMinMax = 0;
  let totalMaxMin2 = 0;
  let totalMinMin2 = 0;
  let totalMaxMax2 = 0;

  let totalMinMax2 = 0;
  let totalMaxMin3 = 0;
  let totalMinMin3 = 0;
  let totalMaxMax3 = 0;

  let totalMinMax3 = 0;
  let totalG1 = 0;
  let totalG1a = 0;
  let totalG2 = 0;
  let totalG2a = 0;
  let totalGaps = 0;

  const topsAll: Record<number, number> = {
    0: 0,
    1: 0,
    2: 0,
    3: 0,
  };

  const topsP: Record<number, number> = {
    0: 0,
    1: 0,
    2: 0,
    3: 0,
  };

  const topsA: Record<number, number> = {
    0: 0,
    1: 0,
    2: 0,
    3: 0,
  };

  // Process ES hits
  result.hits.hits.forEach((val: ESHit) => {
    if (name === "bxj") {
      val._source.timestamp = val._source.systemTime;
      val._source["20"] = val._source.hasOwnProperty("大")
        ? val._source["大"]
        : 0;
      val._source["21"] = val._source.hasOwnProperty("小")
        ? val._source["小"]
        : 0;
      val._source["22"] = val._source.hasOwnProperty("单")
        ? val._source["单"]
        : 0;
      val._source["23"] = val._source.hasOwnProperty("双")
        ? val._source["双"]
        : 0;
      val._source["20_c"] = val._source.hasOwnProperty("大_c")
        ? val._source["大_c"]
        : 0;
      val._source["21_c"] = val._source.hasOwnProperty("小_c")
        ? val._source["小_c"]
        : 0;
      val._source["22_c"] = val._source.hasOwnProperty("单_c")
        ? val._source["单_c"]
        : 0;
      val._source["23_c"] = val._source.hasOwnProperty("双_c")
        ? val._source["双_c"]
        : 0;
    }
    val._source.tm = new Date(val._source.timestamp).format("yyyy-MM-dd hh:mm");
    alls.push(val._source);
  });

  // Handle bxj special case
  if (name === "bxj") {
    const mpm: Record<string, any> = {};
    alls.forEach((item) => {
      if (mpm.hasOwnProperty(item.period)) {
        codes.forEach((code) => {
          mpm[item.period].datas[code] += item[code];
          mpm[item.period].datas[code + "_c"] += item[code + "_c"];
        });
      } else {
        const resultCodes: string[] = [];
        if (item.resultsMap.indexOf("大") > -1) resultCodes.push("20");
        if (item.resultsMap.indexOf("小") > -1) resultCodes.push("21");
        if (item.resultsMap.indexOf("单") > -1) resultCodes.push("22");
        if (item.resultsMap.indexOf("双") > -1) resultCodes.push("23");
        const mp = {
          timestamp: item["timestamp"],
          tm: item["tm"],
          resultCodes: resultCodes.join(", "),
          datas: {} as Record<string, number>,
        };
        codes.forEach((code) => {
          mp.datas[code] = item[code];
          mp.datas[code + "_c"] = item[code + "_c"];
        });
        mpm[item.period] = mp;
      }
    });
    alls = Object.values(mpm);
  } else {
    // 处理非bxj平台数据，确保resultCodes和datas字段存在
    alls = alls.map((item) => {
      if (!item.resultCodes) {
        item.resultCodes = item.resultCodes || "";
      }
      if (!item.datas) {
        item.datas = {};
        codes.forEach((code) => {
          item.datas[code] = item[code] || 0;
          item.datas[code + "_c"] = item[code + "_c"] || 0;
        });
      }
      return item;
    });
  }

  const odds = name === "bxj" ? 0.97 : 0.96;
  const price = 10;

  // Sort by timestamp
  const dts = alls.sort((a, b) => a.timestamp - b.timestamp);

  // Process each data point
  dts.forEach((val) => {
    x.push(val.tm);
    const dt = val;
    const results = dt.resultCodes;

    // Process maxMax2, maxMin2, minMax2, minMin2
    if (results.indexOf(dt.maxMax2) > -1) {
      totalMaxMax2 += price * odds;
    } else {
      totalMaxMax2 -= price;
    }
    if (results.indexOf(dt.maxMin2) > -1) {
      totalMaxMin2 += price * odds;
    } else {
      totalMaxMin2 -= price;
    }
    if (results.indexOf(dt.minMax2) > -1) {
      totalMinMax2 += price * odds;
    } else {
      totalMinMax2 -= price;
    }
    if (results.indexOf(dt.minMin2) > -1) {
      totalMinMin2 += price * odds;
    } else {
      totalMinMin2 -= price;
    }

    // Process maxMax3, maxMin3, minMax3, minMin3(与 "2" 族同一处理方式)
    if (results.indexOf(dt.maxMax3) > -1) {
      totalMaxMax3 += price * odds;
    } else {
      totalMaxMax3 -= price;
    }
    if (results.indexOf(dt.maxMin3) > -1) {
      totalMaxMin3 += price * odds;
    } else {
      totalMaxMin3 -= price;
    }
    if (results.indexOf(dt.minMax3) > -1) {
      totalMinMax3 += price * odds;
    } else {
      totalMinMax3 -= price;
    }
    if (results.indexOf(dt.minMin3) > -1) {
      totalMinMin3 += price * odds;
    } else {
      totalMinMin3 -= price;
    }

    // Process gaps
    const g1gap = Math.abs(dt.datas["20"] - dt.datas["21"]);
    if (dt.datas["20"] > dt.datas["21"]) {
      if (results.indexOf("21") > -1) {
        totalGaps += g1gap;
      } else {
        totalGaps -= 0.96 * g1gap;
      }
    } else {
      if (results.indexOf("20") > -1) {
        totalGaps += g1gap;
      } else {
        totalGaps -= 0.96 * g1gap;
      }
    }

    const g2gap = Math.abs(dt.datas["22"] - dt.datas["23"]);
    if (dt.datas["22"] > dt.datas["23"]) {
      if (results.indexOf("23") > -1) {
        totalGaps += g2gap;
      } else {
        totalGaps -= 0.96 * g2gap;
      }
    } else {
      if (results.indexOf("22") > -1) {
        totalGaps += g2gap;
      } else {
        totalGaps -= 0.96 * g2gap;
      }
    }
    gaps.push(totalGaps);

    // Process g1 and g2
    const group1 = ["20", "21"];
    const group2 = ["22", "23"];
    const datas = dt.datas;

    if (datas[group1[0]] > datas[group1[1]]) {
      if (results.indexOf(group1[1]) > -1) {
        totalG1 += odds;
        total += odds;
      } else {
        totalG1 -= 1;
        total -= 1;
      }
    } else {
      if (results.indexOf(group1[0]) > -1) {
        totalG1 += odds;
        total += odds;
      } else {
        totalG1 -= 1;
        total -= 1;
      }
    }

    if (datas[group2[0]] > datas[group2[1]]) {
      if (results.indexOf(group2[1]) > -1) {
        totalG2 += odds;
        total += odds;
      } else {
        totalG2 -= 1;
        total -= 1;
      }
    } else {
      if (results.indexOf(group2[0]) > -1) {
        totalG2 += odds;
        total += odds;
      } else {
        totalG2 -= 1;
        total -= 1;
      }
    }

    g1.push(totalG1);
    g2.push(totalG2);

    // Process g1a and g2a
    if (
      datas[group1[0]] / datas[group1[0] + "_c"] >
      datas[group1[1]] / datas[group1[1] + "_c"]
    ) {
      if (results.indexOf(group1[1]) > -1) {
        totalG1a += odds;
      } else {
        totalG1a -= 1;
      }
    } else {
      if (results.indexOf(group1[0]) > -1) {
        totalG1a += odds;
      } else {
        totalG1a -= 1;
      }
    }

    if (
      datas[group2[0]] / datas[group2[0] + "_c"] >
      datas[group2[1]] / datas[group2[1] + "_c"]
    ) {
      if (results.indexOf(group2[1]) > -1) {
        totalG2a += odds;
      } else {
        totalG2a -= 1;
      }
    } else {
      if (results.indexOf(group2[0]) > -1) {
        totalG2a += odds;
      } else {
        totalG2a -= 1;
      }
    }

    g1a.push(totalG1a);
    g2a.push(totalG2a);

    // Process vals and tops
    let vals: Array<{ name: string; value: number }> = [];
    codes.forEach((code) => {
      const value = dt.datas[code];
      vals.push({ name: code, value: value ? value : 0 });
    });
    vals = vals.sort((a, b) => b.value - a.value);

    // Process maxMax, maxMin, minMax, minMin
    // 直接读取 ES 文档预计算字段(由上游按 calc.py findLMaxMin 规则写入,
    // 与 maxMax2 等 "2" 族同一处理方式),不再本地重算。
    if (results.indexOf(dt.maxMax) > -1) {
      totalMaxMax += price * odds;
    } else {
      totalMaxMax -= price;
    }
    if (results.indexOf(dt.maxMin) > -1) {
      totalMaxMin += price * odds;
    } else {
      totalMaxMin -= price;
    }
    if (results.indexOf(dt.minMax) > -1) {
      totalMinMax += price * odds;
    } else {
      totalMinMax -= price;
    }
    if (results.indexOf(dt.minMin) > -1) {
      totalMinMin += price * odds;
    } else {
      totalMinMin -= price;
    }

    // Process tops
    vals.forEach((val, index) => {
      if (results.indexOf(val.name) > -1) {
        topsAll[index] += 1 * odds;
        if (index === 3 || index === 0) {
          totalT += 50 * odds;
        }
      } else {
        topsAll[index] -= 1.0;
        if (index === 3 || index === 0) {
          totalT -= 50;
        }
      }
      topsAll[index] = parseFloat(topsAll[index].toFixed(2));
    });

    const sub = 1;
    y.push(total);
    ty.push(totalT);
    maxMiny.push(totalMaxMin / sub);
    minMiny.push(totalMinMin / sub);
    maxMaxy.push(totalMaxMax / sub);
    minMaxy.push(totalMinMax / sub);
    maxMiny2.push(totalMaxMin2 / sub);
    minMiny2.push(totalMinMin2 / sub);
    maxMaxy2.push(totalMaxMax2 / sub);

    minMaxy2.push(totalMinMax2 / sub);
    maxMiny3.push(totalMaxMin3 / sub);
    minMiny3.push(totalMinMin3 / sub);
    maxMaxy3.push(totalMaxMax3 / sub);

    minMaxy3.push(totalMinMax3 / sub);
    top1s.push(topsAll[0] / sub);
    top2s.push(topsAll[1] / sub);
    top3s.push(topsAll[2] / sub);
    top4s.push(topsAll[3] / sub);
  });

  return {
    x,
    y,
    ty,
    maxMiny,
    minMiny,
    maxMaxy,
    minMaxy,
    top1s,
    top2s,
    top3s,
    top4s,
    maxMiny2,
    minMiny2,
    maxMaxy2,
    minMaxy2,
    maxMiny3,
    minMiny3,
    maxMaxy3,
    minMaxy3,

    gaps,
    g1,
    g2,
    g1a,
    g2a,
  };
}
